import { Component } from "@angular/core";

@Component({
  selector: "app-common-folder-in-use-dialog",
  templateUrl: "./common-folder-in-use-dialog.component.html",
  styleUrls: ["./common-folder-in-use-dialog.component.scss"],
  standalone: false
})
export class CommonFolderInUseDialogComponent {
  constructor() {}
}
